export const Constants = {
  baseURL: "https://api.teleportapp.sg/",

  signup_api_url: "/admin/signup",
  signin_api_url: "/admin/login",

  get_all_merchants_api_url: "/merchant/getAllMerchants",
  update_merchant_api_url: "/merchant/update",
  search_merchant_api_url: "/merchant/search",
  // commission //
  create_commission_api_url: "/commission/create",
  update_commission_api_url: "/commission/update",
  get_all_commissions_configurations: "/commission/getAllCommission",
  delete_commission_api_url: "/commission/delete",

  // listings //
  get_all_listings_api_url: "/service/getAll",
  update_listing_api_url: "/service/update",

  // deals //
  get_all_deals: "/deal/getAll",
  update_deal_api_url: "/deal/update",

  //markup
  get_all_markup_api_url: "/markup/getAll",
  add_markup_api_url: "/markup/create",
  delete_markup_api_url: "/markup/delete/",
  update_markup_api_url: "/markup/update",

  // packages //
  get_all_packages_api_url: "/esim/getAllPackagesAdmin",

  // notification //
  get_all_notification_api_url: "/notification/getAll",
  update_notification_api_url: "/notification/update",
  //Activation Steps
  add_activationstep_api_url: "/AS",
  get_activationstep_api_url: "/AS",
  delete_activationstep_api_url: "/AS",
  get_specific_activationstep_api_url: "/AS/getByid",
  edit_activationstep_api_url: "/AS",
  //Articles
  add_article_api_url: "/article/create",
  get_article_api_url: "/article",
  get_specific_article_api_url: "/article/getSpecific",
  delete_article_api_url: "/article",
  edit_article_api_url: "/article",
  // Orders
  get_flight_orders_url: "/esim/getAllEsimOrders",
  get_esim_orders_url: "",
  //Users
  get_all_users_url: "/auth/getAllUsers",
  get_orders_by_user_id_url: "/esim/getOrdersByUserId",
  sentEmailOTP: "/auth/sendEmailOTP",
  updateUserProfile: "/auth/updateUserProfile",
  updateProfile: "/users/updateProfile",
  // Flights
  get_all_flights_url: "/sabre/sabreBargainSearch",
  revalidate_flight_url: "/sabre/sabreRevalidate",
  create_pnr_flight_url: "/sabre/sabrePassengerRecords",
  get_ticket_flight_url: "/sabre/getTicket",
  flightsPreorder: "/flights/preorder",
  //Esim
  get_all_esim_packages_api_url: "/esim/getAllPackages",
  get_supported_locations_api_url: "/esim/getSupportedLocations",
  esimPreorder: "/esim/preorder",

  getRecommendPromos: '/promo/getRecommendPromos'
};
